import React, { useState, Dispatch, useRef, useEffect } from 'react';
import StyledModal from '../../Components/GenericModal/StyledModal';
import { Box, Tabs, Tab, Button } from '@mui/material';
import {
  GenericTableState,
  GenericTableAction
} from '../../Components/GenericTable/genericTableReducer';
import { ISnackbarInput } from '../../Components/CustomUIElements/StyledSnackbar';
import { sharedClasses } from '../../Components/CustomUIElements/sharedClasses';
import { ICandidateSourcingPool } from '../types';
import { initialTableState } from '../../Components/GenericTable/genericTableReducer';
import { candidatePoolAssignmentColumns } from './candidatePoolAssignmentConfig';
import CandidateTab from './CandidateTab';
import EmailTab from './EmailTab';
import EmailCandidateModal from '../EmailCandidateModal';
import { classes } from '../styles';
import { CandidateSourcingAction } from '../candidateSourcingReducer';
import EmailIcon from '@mui/icons-material/Email';
import PoolName from './PoolName';

const IndividualCandidatePoolModal = ({
  isOpen,
  selectedPool,
  individualCandidatePoolsState,
  individualCandidatePoolsDispatch,
  emailsState,
  emailsDispatch,
  handleClose,
  setSnackbarState,
  refetch,
  modalTabValue,
  setModalTabValue,
  candidateSourcingDispatch
}: {
  isOpen: boolean;
  individualCandidatePoolsState: GenericTableState;
  individualCandidatePoolsDispatch: Dispatch<GenericTableAction>;
  emailsState: GenericTableState;
  emailsDispatch: Dispatch<GenericTableAction>;
  selectedPool: ICandidateSourcingPool;
  handleClose: () => void;
  setSnackbarState: (snackbarState: ISnackbarInput) => void;
  refetch: () => void;
  modalTabValue: number;
  setModalTabValue: (i: number) => void;
  candidateSourcingDispatch: Dispatch<CandidateSourcingAction>;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      individualCandidatePoolsDispatch({
        type: 'SET_DEFAULT_DATA',
        payload: initialTableState(candidatePoolAssignmentColumns, {
          sortBy: 'name',
          sortOrder: 'asc'
        })
      });
    }
  }, [isOpen, individualCandidatePoolsDispatch]);

  const handleBulkEmail = () => {
    setIsEmailModalOpen(true);
  };

  const handleCloseEmailModal = () => {
    setIsEmailModalOpen(false);
  };

  return (
    <>
      <StyledModal
        isOpen={isOpen}
        handleClose={handleClose}
        label="Candidate Pool Details"
        styleOverrides={{
          maxWidth: '1100px',
          maxHeight: '1100px'
        }}
        subHeaderStyling={false}
      >
        <Box
          sx={{
            ...sharedClasses.mainModalContent,
            height: '100%',
            paddingInline: '2px',
            marginTop: '15px'
          }}
          ref={containerRef}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              marginBottom: '20px'
            }}
          >
            <PoolName
              selectedPool={selectedPool}
              setSnackbarState={setSnackbarState}
              refetch={refetch}
            />
            <Button
              variant="contained"
              startIcon={<EmailIcon />}
              onClick={handleBulkEmail}
              sx={{ ...sharedClasses.genericButton }}
            >
              Send Bulk Email
            </Button>
          </Box>
          <Tabs
            value={modalTabValue}
            onChange={(e, value) => setModalTabValue(value)}
            TabIndicatorProps={{
              sx: {
                ...classes.tabIndicator,
                maxWidth: modalTabValue ? '4.8em' : '5.75em'
              }
            }}
            sx={{
              ...classes.tabs,
              margin: '1rem 0 2.5rem 0',
              borderBottom: '1px solid #EEEEEE'
            }}
          >
            <Tab label="Candidate" id="candidate-tab" />
            <Tab label="Emails" id="emails-tab" />
          </Tabs>
          {modalTabValue ? (
            <EmailTab
              isOpen={isOpen}
              selectedPool={selectedPool}
              emailsState={emailsState}
              emailsDispatch={emailsDispatch}
              candidateSourcingDispatch={candidateSourcingDispatch}
            />
          ) : (
            <CandidateTab
              isOpen={isOpen}
              setSnackbarState={setSnackbarState}
              selectedPool={selectedPool}
              candidatePoolsState={individualCandidatePoolsState}
              candidatePoolsDispatch={individualCandidatePoolsDispatch}
            />
          )}
        </Box>
      </StyledModal>

      <EmailCandidateModal
        isOpen={isEmailModalOpen}
        onClose={handleCloseEmailModal}
        selectedPoolIds={[selectedPool.id]}
      />
    </>
  );
};

export default IndividualCandidatePoolModal;
